import {Article} from "@/types/Article.d";

import styles from './TileList.module.scss'


export default function TileList({ children }: {children: any}) {

  return <div className={styles.tileList}>{children}</div>
}
